var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHeart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9999 19.9075C7.40079 17.2881 4.83574 14.6846 3.59537 12.4257C2.32586 10.1137 2.43663 8.16639 3.14108 6.78434C4.58905 3.94362 8.70665 3.03524 11.2154 6.20822L11.9998 7.20027L12.7842 6.20827C15.2934 3.03516 19.4113 3.94368 20.8592 6.78434C21.5636 8.16637 21.6744 10.1136 20.4048 12.4256C19.1643 14.6846 16.5991 17.2881 11.9999 19.9075ZM11.9999 4.10613C8.47068 0.752522 3.2643 2.13856 1.35921 5.87609C0.313666 7.9273 0.299384 10.5784 1.84227 13.3883C3.37147 16.1732 6.42038 19.1128 11.5161 21.9293L11.9998 22.1967L12.4836 21.9293C17.5795 19.1128 20.6285 16.1732 22.1578 13.3883C23.7008 10.5785 23.6866 7.92732 22.6411 5.87609C20.736 2.13849 15.5294 0.752573 11.9999 4.10613Z",
    fill: "#080134"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/heart.b42a3ea1.svg";
export { ForwardRef as ReactComponent };